import { withInstall } from '../../utils'

import _Dialog from './src/dialog.vue'

export const SdDialog = withInstall(_Dialog)
export default SdDialog

export * from './src/dialog'
